import React from 'react';
import { isRubric } from 'legacy/src/utility/progressHelpers';
import { SecureInfoIcon } from 'legacy-src/utility';

export default function useAttestation({
  subjectData = {},
  showAttestationFlag,
  isStudent,
}) {
  const secureQuestionErrorText = (
    <span>This question appears on an official practice exam.</span>
  );

  const isApSubject = subjectData.subjectProgram === 'AP';
  const showQuestionTitlePrefix = isApSubject;
  const isAttestationEnabled = showAttestationFlag && isApSubject;

  const secureMessageText =
    'This question appears on an official practice exam.';

  const generateItemTitle = (item, index) => {
    if (!isAttestationEnabled || isRubric(item)) {
      return item.title;
    }

    return `Q${index + 1} ${item.title}`;
  };

  /**
   * Check if item should be available for student
   * @param isSecureItem {Boolean}
   * @returns {boolean}
   */
  const isItemAvailable = (isSecureItem) => {
    if (!isAttestationEnabled || !isStudent) {
      return true;
    }

    if (isStudent) {
      return !isSecureItem;
    }
  };

  const getSecureIconForItem = (item) => {
    const isPE = item.is_practice_exam;
    const hasSQ = item.contains_secure_questions;

    if (showAttestationFlag && (isPE || hasSQ)) {
      return <SecureInfoIcon isQuestion={false} />;
    }
    return null;
  };

  const hasScrambleablePEs = (isPE) => !showAttestationFlag || !isPE;

  return {
    isApSubject,
    isAttestationEnabled,
    showQuestionTitlePrefix,
    isItemAvailable,
    getSecureIconForItem,
    secureQuestionErrorText,
    generateItemTitle,
    secureMessageText,
    hasScrambleablePEs,
  };
}
